if (!customElements.get("tabbed-featured-collection")) {
  class TabbedFeaturedCollection extends HTMLElement {
    constructor() {
      super();
      this.swipers = {};
    }

    connectedCallback() {
      this.init();
    }

    init() {
      const tabs = this.querySelectorAll(".collection-tabs_tab");
      const panels = this.querySelectorAll(".collection-tabs_panel");
      const viewCollectionLink = this.closest(
        ".container--large",
      )?.querySelector(".section-heading__actions a");
      const viewCollectionLink2 = this.querySelector(
        ".js-view-collection-link",
      );

      tabs.forEach((tab) => {
        tab.addEventListener("click", (e) => {
          e.preventDefault();

          tabs.forEach((t) => {
            t.classList.remove("active");
            t.setAttribute("aria-selected", "false");
          });
          panels.forEach((panel) => {
            panel.classList.remove("active");
            panel.setAttribute("aria-hidden", "true");
          });

          tab.classList.add("active");
          tab.setAttribute("aria-selected", "true");

          const targetPanelId = tab
            .querySelector("button")
            .getAttribute("aria-controls");
          const collectionUrl = tab
            .querySelector("button")
            .getAttribute("data-collection-url");

          if (viewCollectionLink && collectionUrl) {
            viewCollectionLink.setAttribute("href", collectionUrl);
          }
          if (viewCollectionLink2 && collectionUrl) {
            viewCollectionLink2.setAttribute("href", collectionUrl);
          }

          panels.forEach((panel) => {
            if (panel.id === targetPanelId) {
              panel.classList.add("active");
              panel.setAttribute("aria-hidden", "false");
              this.initSwiper(panel);
            }
          });
        });
      });

      // Initialize active tab
      const activePanel = this.querySelector(".collection-tabs_panel.active");
      if (activePanel) {
        this.initSwiper(activePanel);
      }
    }

    initSwiper(panel) {
      const swiperEl = panel.querySelector(".tabbed-featured-swiper");
      if (!swiperEl || swiperEl.classList.contains("swiper-initialized"))
        return;

      const panelId = panel.id;

      this.swipers[panelId] = new Swiper(swiperEl, {
        slidesPerView: 2,
        spaceBetween: 5,
        grabCursor: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: swiperEl.querySelector('.swiper-button-next'),
          prevEl: swiperEl.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 10,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 10,
          },
        },
        on: {
          init: () => {
            swiperEl.classList.add("swiper-initialized");
            swiperEl.classList.add("is-initialized");
          },
        },
      });
    }
  }

  customElements.define("tabbed-featured-collection", TabbedFeaturedCollection);

  document.addEventListener("shopify:section:load", (e) => {
    if (e.target.classList.contains("mount-tabbed-featured-collection")) {
      e.target.querySelector("tabbed-featured-collection")?.init();
    }
  });
}
